import { SidebarItem } from '@backstage/core-components';
import AssessmentIcon from '@material-ui/icons/Assessment';
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import { useIsPlatformAdmin } from './useIsPlatformAdmin';

/** `tenants` are the ones the user administers, from useAdministrationTenants. */
export function PolicyAdministrationNavItem({
  tenants,
}: {
  tenants: string[];
}) {
  const backstageAdmin = useIsPlatformAdmin();

  return tenants.length > 0 || backstageAdmin ? (
    <>
      <SidebarItem
        icon={AssessmentIcon}
        to="/policies/admin"
        text="Policy administration"
      />
      {tenants.length > 0 && (
        <SidebarItem
          icon={DonutSmallIcon}
          to={`/policies/tenants/${encodeURIComponent(tenants[0])}`}
          text="Tenant quotas"
        />
      )}
    </>
  ) : null;
}
